import { Outlet } from "react-router";
import Navigation from "../widgets/Navigation";
import Footer from "../widgets/Footer";

export default function MainLayout(props) {
    return (
        <div className="bg-gray-50 min-h-screen flex flex-col">
            <Navigation />
            <Outlet />
            <Footer />
        </div>
    )
}